export const formatCurrency = (value: number | null | undefined): string => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(value || 0);
};

export const statusColors: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-700',
  submitted: 'bg-blue-100 text-blue-700',
  pending: 'bg-yellow-100 text-yellow-700',
  analysis: 'bg-indigo-100 text-indigo-700',
  approval: 'bg-amber-100 text-amber-700',
  reviewed: 'bg-blue-100 text-blue-700',
  approved: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
  disbursed: 'bg-emerald-100 text-emerald-700',
};

export const statusLabels: Record<string, string> = {
  draft: 'Draft',
  submitted: 'Diajukan',
  pending: 'Menunggu Approval',
  analysis: 'Analisis',
  approval: 'Approval',
  reviewed: 'Direview',
  approved: 'Disetujui',
  rejected: 'Ditolak',
  disbursed: 'Dicairkan',
};

export const creditTypeLabels: Record<string, string> = {
  working_capital: 'Modal Kerja',
  investment: 'Investasi',
  consumer: 'Konsumtif',
  kpr: 'KPR',
  kendaraan: 'Kendaraan',
  multiguna: 'Multiguna',
};
